/**
 * Fireblocks integration API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssetVaultValue } from './assetVaultValue';

export interface Vault {
  id?: string;
  name?: string;
  hiddenOnUI?: boolean;
  customerRefId?: string;
  autoFuel?: boolean;
  assets?: Array<AssetVaultValue>;
}
